/******/ (() => { // webpackBootstrap
/*!***************************************!*\
  !*** ./zrc/scripts/templates/blog.js ***!
  \***************************************/
class Blog extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.configHeightsTexts();
  }
  configHeightsTexts() {
    var articleTitles = this.container.querySelectorAll('.article-card-title');
    var articleExcerpts = this.container.querySelectorAll('.article-card-excerpt');
    var gridOptions = [{
      breakpoint: 1440,
      columns: 3
    }, {
      breakpoint: 1023,
      columns: 2
    }, {
      breakpoint: 660,
      columns: 1
    }];
    window.setHeightCardTexts(articleTitles, '--height-title', gridOptions);
    window.setHeightCardTexts(articleExcerpts, '--height-excerpt', gridOptions);
  }
}
if (window.customElements.get('blog-section') == null) {
  window.customElements.define('blog-section', Blog);
}
/******/ })()
;